<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <data-table :headings="vehicleHeadings" :data="driverVehicles" :hasActions="false" :hasNoFilter="true">
                    
                </data-table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" :disabled="loading" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>